module.exports = __webpack_public_path__ + "static/media/4_r_meshok_90.63_78.52.3c3648f2.png";